import React, { useRef } from "react";

import { useSelector } from "react-redux";
import {
  getContent,
  getDelayedIndexBasedAnimationTime,
  getRightContent,
  getVisibleSensorAnimation,
} from "../assets/js/utils";
import ContentTitle from "./ContentTitle";
import MileStone from "./MileStone";

import useKeyPropRtlLanguage from "./hooks/useKeyPropRtlLanguage";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import useWindowSize from "./hooks/useWindowSize";
import ReactVisibilitySensor from "react-visibility-sensor";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

function Content2(props) {
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  const sections = useSelector((state) => state.ui.sections);
  const swiperRef = useRef();
  const windowWidth = useWindowSize();
  const keyAnimationRestartWhenChangeLanguage = useKeyPropRtlLanguage();

  return (
    <div style={{ width: "100%" }} key={keyAnimationRestartWhenChangeLanguage}>
      <div className="general-m">
        <ContentTitle
          label={getRightContent(
            generalSettings.rtlLanguage,
            getContent().sections[sections.currentSection].content.title
          )}
        />

        <div className="general-separator"></div>
        {/* <div className="general-separator"></div> */}
      </div>

      <div className="custom-swiper mt-401">
        <ReactVisibilitySensor partialVisibility>
          {({ isVisible }) => (
            <div
              className="custom-swiper_control-buttons"
              style={getVisibleSensorAnimation(
                isVisible,
                `fade-in-40px 1s forwards`
              )}
            >
              <div
                className="custom-swiper__button-wrapper"
                onClick={() =>
                  swiperRef.current && swiperRef.current.slidePrev()
                }
              >
                <div className="custom-swiper__prev-button"></div>
              </div>

              <div
                className="custom-swiper__button-wrapper"
                onClick={() =>
                  swiperRef.current && swiperRef.current.slideNext()
                }
              >
                <div className="custom-swiper__next-button"></div>
              </div>
            </div>
          )}
        </ReactVisibilitySensor>

        <div className="custom-swiper__wrapper">
          <Swiper
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            // slidesPerView={
            //   windowWidth < 300
            //     ? 1.2
            //     : windowWidth < 400
            //     ? 1.35
            //     : windowWidth < 520
            //     ? 1.5
            //     : windowWidth < 768
            //     ? 2.5
            //     : windowWidth < 1240
            //     ? 3
            //     : windowWidth < 1440
            //     ? 4
            //     : 5
            // }
            // slidesPerView={
            //   windowWidth > 1024
            //     ? windowWidth / 290
            //     : windowWidth > 768
            //     ? windowWidth / 270
            //     : windowWidth / 235
            // }
            breakpoints={{
              280: {
                width: 250,
                slidesPerView: 1,
              },
              // when window width is >= 640px
              440: {
                width: 440,
                slidesPerView: 1.2,
              },
              540: {
                width: 540,
                slidesPerView: 1.8,
              },
              // when window width is >= 768px
              768: {
                width: 768,
                slidesPerView: 2.4,
              },
            }}
            spaceBetween={20}
            // loop={true}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            // className="mySwiper"
            // centeredSlides={windowWidth < 768 ? true : false}
            grabCursor={true}
          >
            {getContent().sections[
              sections.currentSection
            ].content.mileStones.map((mileStone, index) => (
              <SwiperSlide key={index}>
                <ReactVisibilitySensor partialVisibility>
                  {({ isVisible }) => (
                    <div
                      className="container-scrollable-x__card-arrow-first-section"
                      // style={getVisibleSensorAnimation(
                      //   isVisible,
                      //   `fade-in-40px 1s ${getDelayedIndexBasedAnimationTime(
                      //     windowWidth,
                      //     index,
                      //     0.1
                      //   )}s backwards`
                      // )}
                    >
                      <MileStone
                        // applyBorderClass={index === scrollOffset}
                        // applyUpperIcon={mileStone.applyUpperIcon}
                        counterValue={mileStone.counterValue}
                        upperPoint={index % 2 === 0}
                        suffix={getRightContent(
                          generalSettings.rtlLanguage,
                          mileStone.suffix || ["", ""]
                        )}
                        prefix={getRightContent(
                          generalSettings.rtlLanguage,
                          mileStone.prefix || ["", ""]
                        )}
                        bottomText={getRightContent(
                          generalSettings.rtlLanguage,
                          mileStone.bottomText
                        )}
                        replaceCounter={getRightContent(
                          generalSettings.rtlLanguage,
                          mileStone.replaceCounter || ["", ""]
                        )}
                      />
                    </div>
                  )}
                </ReactVisibilitySensor>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      {/* </div> */}
    </div>
  );
}

export default Content2;
